import styles from "./none.module.css";

type Tnone = {
  hh: number;
};

function None(props: Tnone) {
  const backgraundMain = {
    height: `${props.hh}px`,
  };

  return <div className={styles.main} style={backgraundMain}></div>;
}

export default None;
